export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mb-8">
            了解黑料入口的使命与坚持
          </p>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10 text-left">
            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700">
              <p className="leading-relaxed mb-4">
                黑料入口创立于对信息透明的追求。在信息碎片化时代，公众对热点事件的了解往往停留在标题和片段，
                缺乏对事件全貌的认知。我们希望搭建一个百科式科普平台，以客观、全面、有条理的方式，
                为每一件引发关注的"黑料事件"提供完整的背景、经过和解读。
              </p>
              <p className="leading-relaxed mb-4">
                我们的编辑团队由资深媒体人、行业分析师和法律顾问组成，坚持多维度交叉验证的编辑原则。
                每一篇专题内容都经过严格的事实核查和信息溯源，确保读者获得的是经得起推敲的可靠信息。
              </p>
              <p className="leading-relaxed mb-4">
                我们相信，了解事件的完整面貌是理性讨论的前提。黑料入口不做情绪的煽动者，
                而做事实的整理者——帮助每一位读者在纷繁的信息中，找到清晰的脉络。
              </p>
              <p className="leading-relaxed">
                目前平台已累计盘点超过 <strong className="text-primary-600 font-semibold">500</strong> 个事件专题，
                覆盖娱乐、商业、社会、科技等多个领域，每日更新最新热点解读。
                感谢每一位读者的支持与信任。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
              <div className="text-center p-4 rounded-xl bg-background-100">
                <p className="font-heading text-2xl font-bold text-primary-600 mb-1">500+</p>
                <p className="text-xs text-foreground-500">事件专题</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100">
                <p className="font-heading text-2xl font-bold text-primary-600 mb-1">12个</p>
                <p className="text-xs text-foreground-500">覆盖领域</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100">
                <p className="font-heading text-2xl font-bold text-primary-600 mb-1">每日</p>
                <p className="text-xs text-foreground-500">实时更新</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100">
                <p className="font-heading text-2xl font-bold text-primary-600 mb-1">3重</p>
                <p className="text-xs text-foreground-500">信源验证</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}